export const brl = (v) => Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: Number(v) % 1 ? 2 : 0 });

export const featuredPrice = (p) => (p?.prices || []).find((x) => x.highlight) || (p?.prices || [])[0] || null;

export const withDiscount = (value, off) => Math.round(value * (1 - off / 100) * 100) / 100;

// Price in brand orange; with discount: original struck in gray + discounted in green.
export function PriceTag({ item, off = 0, className = "" }) {
  if (!item) return null;
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-2 ${className}`}>
      <span className="font-semibold text-slate-700">{item.name}:</span>
      {off > 0 ? (
        <>
          <span className="text-slate-400 line-through">{brl(item.value)}</span>
          <span className="font-extrabold text-green-600">{brl(withDiscount(item.value, off))}</span>
        </>
      ) : (
        <span className="font-extrabold text-orange-600">{brl(item.value)}</span>
      )}
    </span>
  );
}
